import { createAction } from '@reduxjs/toolkit';

export const importLexiconContainerActions = {
  navigateTo: createAction<{ navigateTo: string }>('ImportLexiconContainer/NavigateTo'),
};
